import { useState } from "react";

// The mobile money number a payment prompt goes to. The account phone is
// used unless the person asks for another, so they aren't asked for their
// number again every time they pay. Leaving `value` empty means "use the
// account phone" — the server falls back to it.
export default function MomoPhoneField({ accountPhone, value, onChange, className = "" }) {
  const [editing, setEditing] = useState(!accountPhone || Boolean(value));

  if (!editing) {
    return (
      <p className={`text-xs text-muted-foreground ${className}`}>
        The payment prompt goes to <span className="font-medium text-slate-900">{accountPhone}</span>.{" "}
        <button type="button" onClick={() => setEditing(true)} className="font-medium text-primary hover:underline">
          Use a different number
        </button>
      </p>
    );
  }

  return (
    <input
      type="tel"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={accountPhone ? `Mobile money number (default ${accountPhone})` : "Mobile money number"}
      aria-label="Mobile money number"
      className={`w-full rounded-xl border border-border p-3 text-sm ${className}`}
    />
  );
}
